"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationAgentServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const ConversationSessionService_1 = __importStar(require("./ConversationSessionService"));
const ConversationPlaybackService_1 = __importStar(require("./ConversationPlaybackService"));
const conversation_agent_events_1 = require("../../../../common/constants/conversation-agent-events");
/**
 * Main conversation agent service that coordinates all conversation-related functionality
 * This is a simplified facade that delegates to specialized services
 */
let ConversationAgentService = class ConversationAgentService extends client_1.RWSService {
    constructor(sessionService, playbackService) {
        super();
        this.sessionService = sessionService;
        this.playbackService = playbackService;
        this.webChatComponent = null;
        this.duringSpeech = false;
        this.currentStreamAbortController = null;
        this.streamQueue = Promise.resolve();
        this.isStreamingText = false;
    }
    init(chatComponent) {
        this.webChatComponent = chatComponent;
        this.sessionService.init(chatComponent);
    }
    /**
     * Start a conversation agent session
     */
    async startConversation(request, callbacks) {
        // Wrap the onResponse callback to handle audio playback
        const wrappedCallbacks = {
            ...callbacks,
            onResponse: (response) => {
                var _a;
                // Handle audio playback automatically only if there's no onAudioResponse callback
                // or if onAudioResponse doesn't return true (indicating it handled the audio)
                if (response.responseAudio && !callbacks.onAudioResponse) {
                    this.playbackService.playAudioFromBase64(response.responseAudio)
                        .catch(error => console.error('Audio playback failed:', error));
                }
                // Call the original callback
                (_a = callbacks.onResponse) === null || _a === void 0 ? void 0 : _a.call(callbacks, response);
            }
        };
        return this.sessionService.startConversation(request, wrappedCallbacks);
    }
    /**
     * Start a text-read session for streaming LLM text chunks to Azure TTS
     */
    async startTextReadSession(request, callbacks) {
        this.resetTextStream();
        return this.startConversation(request, callbacks);
    }
    /**
     * Reset the text-to-audio streaming state and clear any pending chunks
     */
    resetTextStream() {
        var _a;
        (_a = this.currentStreamAbortController) === null || _a === void 0 ? void 0 : _a.abort();
        this.currentStreamAbortController = new AbortController();
        this.streamQueue = Promise.resolve();
        this.isStreamingText = true;
    }
    /**
     * Stream a text chunk from LLM to backend for Azure TTS audio generation
     * and playback the returned audio response.
     * Requests are serialized through an internal queue so chunks are always
     * sent and played back in the order they were received.
     */
    async streamTextChunkToAudio(sessionId, textChunk, isFinal = false) {
        if (!this.isStreamingText) {
            return Promise.reject(new Error('Text streaming is not active'));
        }
        const enqueue = this.streamQueue.then(() => this.sendStreamTextChunkToAudio(sessionId, textChunk, isFinal));
        this.streamQueue = enqueue.catch(() => { });
        return enqueue;
    }
    /**
     * Internal implementation of streamTextChunkToAudio, serialized by streamQueue.
     */
    sendStreamTextChunkToAudio(sessionId, textChunk, isFinal) {
        return new Promise((resolve, reject) => {
            var _a, _b;
            if (!this.isStreamingText || ((_a = this.currentStreamAbortController) === null || _a === void 0 ? void 0 : _a.signal.aborted)) {
                reject(new Error('Text streaming aborted or not active'));
                return;
            }
            const chunkId = `${sessionId}_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
            let resolved = false;
            let unsubscribe = null;
            let onAbort;
            const cleanup = () => {
                var _a;
                clearTimeout(timeout);
                if (unsubscribe) {
                    unsubscribe();
                    unsubscribe = null;
                }
                (_a = this.currentStreamAbortController) === null || _a === void 0 ? void 0 : _a.signal.removeEventListener('abort', onAbort);
            };
            onAbort = () => {
                if (!resolved) {
                    cleanup();
                    reject(new Error('Text streaming aborted'));
                }
            };
            (_b = this.currentStreamAbortController) === null || _b === void 0 ? void 0 : _b.signal.addEventListener('abort', onAbort, { once: true });
            const timeout = setTimeout(() => {
                if (!resolved) {
                    cleanup();
                    reject(new Error('Timeout waiting for text chunk audio response'));
                }
            }, 30000);
            let playbackStartedDispatched = false;
            unsubscribe = this.sessionService.listenForEvent(conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.TEXT_CHUNK_AUDIO_RESPONSE, (data) => {
                var _a, _b, _c;
                if (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.sessionId) === sessionId && ((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.chunkId) === chunkId && ((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.audio)) {
                    if (!this.isStreamingText) {
                        return;
                    }
                    if (!playbackStartedDispatched) {
                        playbackStartedDispatched = true;
                        window.dispatchEvent(new CustomEvent('conversation-agent:playback-started', {
                            detail: { sessionId },
                            bubbles: true
                        }));
                    }
                    resolved = true;
                    cleanup();
                    this.playbackService.playAudioFromBase64(data.data.audio)
                        .then(() => resolve())
                        .catch((error) => {
                        console.error('❌ [ConversationAgentService] Text chunk audio playback failed:', error);
                        reject(error);
                    });
                }
            });
            try {
                this.sessionService.sendWebSocketMessage(conversation_agent_events_1.CONVERSATION_AGENT_ROUTES.STREAM_TEXT_CHUNK, {
                    sessionId,
                    textChunk,
                    isFinal,
                    chunkId
                });
            }
            catch (error) {
                cleanup();
                reject(error);
            }
        });
    }
    /**
     * Start real-time audio streaming for a session
     */
    async startAudioStreaming(sessionId, options) {
        return this.sessionService.startAudioStreaming(sessionId, options);
    }
    /**
     * Start manual recording for a session (legacy - now uses streaming)
     */
    async startManualRecording(sessionId, options) {
        return this.sessionService.startManualRecording(sessionId, options);
    }
    /**
     * Stop audio streaming
     */
    async stopAudioStreaming(sessionId) {
        return this.sessionService.stopAudioStreaming(sessionId);
    }
    /**
     * Stop recording and send audio
     */
    async stopVoiceStreaming() {
        return this.sessionService.stopVoiceStreaming();
    }
    /**
     * Pause recording (keep Azure session alive)
     */
    async pauseRecording(sessionId) {
        try {
            this.sessionService.sendWebSocketMessage('pause_recording', { sessionId });
            return true;
        }
        catch (error) {
            console.error('Failed to pause recording:', error);
            return false;
        }
    }
    /**
     * Resume recording (Azure session should still be alive)
     */
    async resumeRecording(sessionId) {
        try {
            this.sessionService.sendWebSocketMessage('resume_recording', { sessionId });
            return true;
        }
        catch (error) {
            console.error('Failed to resume recording:', error);
            return false;
        }
    }
    /**
     * End a conversation session
     */
    async endConversationAgent(sessionId, reason = 'unknown') {
        return this.sessionService.endConversationAgent(sessionId, reason);
    }
    /**
     * Check if WebSocket is connected
     */
    isWsConnected() {
        return this.sessionService.isWsConnected();
    }
    /**
     * Check if a session is active
     */
    isSessionActive(sessionId) {
        return this.sessionService.isSessionActive(sessionId);
    }
    /**
     * Set audio playback volume
     */
    setVolume(volume) {
        this.playbackService.setVolume(volume);
    }
    /**
     * Get current volume
     */
    getVolume() {
        return this.playbackService.getVolume();
    }
    /**
     * Check if audio is currently playing
     */
    isSpeaking() {
        return this.playbackService.getIsSpeaking();
    }
    /**
     * Stop current audio playback
     */
    stopPlayback() {
        var _a;
        this.playbackService.stopPlayback();
        this.isStreamingText = false;
        (_a = this.currentStreamAbortController) === null || _a === void 0 ? void 0 : _a.abort();
        this.currentStreamAbortController = null;
        this.streamQueue = Promise.resolve();
    }
    async pausePlayback() {
        await this.playbackService.pausePlayback();
    }
    async resumePlayback() {
        await this.playbackService.resumePlayback();
    }
    /**
     * Interrupt audio playback (for when user starts speaking during agent response)
     */
    interruptPlayback() {
        var _a;
        this.playbackService.interruptPlayback();
        this.isStreamingText = false;
        (_a = this.currentStreamAbortController) === null || _a === void 0 ? void 0 : _a.abort();
        this.currentStreamAbortController = null;
        this.streamQueue = Promise.resolve();
    }
    /**
     * Play audio from base64 string
     */
    async playAudioFromBase64(audioBase64) {
        return this.playbackService.playAudioFromBase64(audioBase64);
    }
    /**
     * Set callback for speaking status changes
     */
    setOnSpeakingChanged(callback) {
        this.playbackService.setOnSpeakingChanged(callback);
    }
    /**
     * Remove speaking status callback
     */
    removeOnSpeakingChanged() {
        this.playbackService.removeOnSpeakingChanged();
    }
    /**
     * Listen for WebSocket events (expose session service event listening)
     */
    listenForEvent(eventName, callback) {
        return this.sessionService.listenForEvent(eventName, callback);
    }
    /**
     * Clean up all resources
     */
    destroy() {
        this.sessionService.destroy();
        this.playbackService.destroy();
        this.webChatComponent = null;
    }
};
exports.ConversationAgentServiceInstance = ConversationAgentService;
// WebSocket event names used by the conversation agent
ConversationAgentService.EVENTS = conversation_agent_events_1.CONVERSATION_AGENT_EVENTS;
// WebSocket route names used by the conversation agent
ConversationAgentService.ROUTES = conversation_agent_events_1.CONVERSATION_AGENT_ROUTES;
exports.ConversationAgentServiceInstance = ConversationAgentService = __decorate([
    __param(0, ConversationSessionService_1.default),
    __param(1, ConversationPlaybackService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof ConversationSessionService_1.ConversationSessionServiceInstance !== "undefined" && ConversationSessionService_1.ConversationSessionServiceInstance) === "function" ? _a : Object, typeof (_b = typeof ConversationPlaybackService_1.ConversationPlaybackServiceInstance !== "undefined" && ConversationPlaybackService_1.ConversationPlaybackServiceInstance) === "function" ? _b : Object])
], ConversationAgentService);
exports.default = ConversationAgentService.getSingleton();
